import React, { useId } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { Checkbox, CircularProgress } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useQuery } from '@tanstack/react-query';
import { getListClientsByAppInstance } from 'redux/slices/appInstance/apis';
const icon = <CheckBoxOutlineBlankIcon fontSize='small' />;
const checkedIcon = <CheckBoxIcon fontSize='small' />;

const FIELD_NAME = 'idpClientList';
const KEY = 'ClientId';
const LABEL = 'ClientId';

const AppIdpClientSelect = (props) => {
  const {
    appInstanceId,
    error,
    helperText,
    value = [],
    required,
    handleInputChange,
    excludes,
    textFieldProps,
    isMultiple = false,
    queryKey = '',
    ...rest
  } = props;

  const { data, isLoading } = useQuery({
    queryKey: ['idp-client-list-select' + queryKey],
    queryFn: () => getListClientsByAppInstance(appInstanceId),
  });

  const id = useId();

  return (
    <Autocomplete
      fullWidth
      multiple={isMultiple}
      disableCloseOnSelect={isMultiple}
      value={value}
      id={`${FIELD_NAME}-select-${id}`}
      name={FIELD_NAME}
      options={
        data?.data?.filter((e) => !excludes?.some((f) => f[KEY] === e[KEY])) ??
        []
      }
      getOptionLabel={(option) => option[LABEL]}
      isOptionEqualToValue={(option, value) => {
        return option?.[KEY] === value?.[KEY];
      }}
      renderOption={(props, option, { selected }) => {
        const { key, ...optionProps } = props;
        return (
          <li {...optionProps} key={option?.[KEY]}>
            {isMultiple && (
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
            )}
            {option[LABEL]}
          </li>
        );
      }}
      loading={isLoading}
      renderInput={(params) => (
        <TextField
          {...params}
          required={required}
          error={error}
          helperText={helperText}
          placeholder={isMultiple ? 'Select Client' : 'Select Clients'}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {isLoading ? (
                  <CircularProgress color='inherit' size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
          {...textFieldProps}
        />
      )}
      {...rest}
    />
  );
};

export default React.memo(AppIdpClientSelect);
